module.exports = __webpack_public_path__ + "fonts/ClearSans-Regular-webfont051b44622bff6697c5591a681f33eb6a.woff";